// Track events
export const ERROR_MESSAGE_DISPLAYED = 'errorMessageDisplayed';
export const FAST_ACCOUNT_CREATED = 'fastAccountCreated';
export const FORM_SUBMIT = 'formSubmit';
export const FORM_SUCCESS = 'formSuccess';
export const FORM_ERROR = 'formError';
export const INTERACT = 'interact';
export const MODAL_VIEWED = 'modalViewed';
export const SWITCH_TO_PHONE_AUTHENTICATION = 'switchToPhoneAuthentication';
export const SWITCH_TO_EMAIL_AUTHENTICATION = 'switchToEmailAuthentication';
export const SIGNUP_SUBMIT = 'signupSubmit';
export const SIGNUP_SUCCESS = 'signupSuccess';
export const SIGNUP_AUTH_SUBMIT = 'signupAuthSubmit';
export const SIGNUP_AUTH_SUCCESS = 'signupAuthSuccess';
export const SIGNIN_SUBMIT = 'signinSubmit';
export const SIGNIN_SUCCESS = 'signinSuccess';
export const SIGNIN_AUTH_SUBMIT = 'signinAuthSubmit';
export const SIGNIN_AUTH_SUCCESS = 'signinAuthSuccess';
export const SEARCH = 'search';

export const INTERACTION_CLICK = 'click';

export const PAYMENT_ALL_INFO_VALID = 'paymentInfoValid';
export const PAYMENT_METHOD_SUBMIT_CLICK = 'paymentMethodSubmitClick';

export const INITIAL_SUBSCRIPTION = 'initialSubscription';

export enum AnalyticsAction {
  PAGE = 'page',
  TRACK = 'track',
  IDENTIFY = 'identify',
}
